import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import { getElementMethods } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { updateDesktopElement } from 'crazyEditor/redux/modules/element/actions/desktopElementActions';
import { updateMobileElement } from 'crazyEditor/redux/modules/element/actions/mobileElementActions';
import editorConstants from 'crazyEditor/core/constants/editorConstants';
import CustomSvgIconButtonPropMenu from '../../shared/CustomSvgIconButtonPropMenu';
import { getSelectedElements } from 'crazyEditor/redux/modules/element/elementSelectors';

@connect(
  state => ({
    selectedElements: getSelectedElements(state)
  }),
  {updateDesktopElement, updateMobileElement}
)
@Radium
export default class FontEmphasisAndAlign extends Component {
  updateElement = (updateGetter) => {
    const {updateDesktopElement, updateMobileElement, isMobileView} = this.props;
    const element = this.props.selectedElements[0];
    const updateFn = isMobileView ? updateMobileElement : updateDesktopElement;
    updateFn(element.id, updateGetter(element));
  };

  render() {
    const element = this.props.selectedElements[0];
    const elementMethods = getElementMethods(element.type);
    const textAlign = elementMethods.getTextAlign(element);
    return (
      <div
        style={[{display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: '10px', position: 'relative', top: '10px'}, this.props.style]}>
        <div>
          <CustomSvgIconButtonPropMenu
            iconPath="M13.5,15.5H10V12.5H13.5A1.5,1.5 0 0,1 15,14A1.5,1.5 0 0,1 13.5,15.5M10,6.5H13A1.5,1.5 0 0,1 14.5,8A1.5,1.5 0 0,1 13,9.5H10M15.6,10.79C16.57,10.11 17.25,9 17.25,8C17.25,5.74 15.5,4 13.25,4H7V18H14.04C16.14,18 17.75,16.3 17.75,14.21C17.75,12.69 16.89,11.39 15.6,10.79Z"
            tooltip="Make text bold"
            tooltipPosition="top-center"
            checked={elementMethods.getIsBold(element)}
            onClick={this.updateElement.bind(this, elementMethods.getToggleBold)}
          />
          <CustomSvgIconButtonPropMenu
            iconPath="M5,21H19V19H5V21M12,17A6,6 0 0,0 18,11V3H15.5V11A3.5,3.5 0 0,1 12,14.5A3.5,3.5 0 0,1 8.5,11V3H6V11A6,6 0 0,0 12,17Z"
            tooltipPosition="top-center"
            tooltip="Underline text"
            checked={elementMethods.getIsUnderline(element)}
            onClick={this.updateElement.bind(this, elementMethods.getToggleUnderline)}
          />
          <CustomSvgIconButtonPropMenu iconPath="M10,4V7H12.21L8.79,15H6V18H14V15H11.79L15.21,7H18V4H10Z"
                                       tooltipPosition="top-center"
                                       tooltip="Make text italic"
                                       checked={elementMethods.getIsItalic(element)}
                                       onClick={this.updateElement.bind(this, elementMethods.getToggleItalic)}
          />
        </div>
        <div style={{position: 'relative', top: '-13px'}}>
          <CustomSvgIconButtonPropMenu
            iconPath="M3,3H21V5H3V3M3,7H15V9H3V7M3,11H21V13H3V11M3,15H15V17H3V15M3,19H21V21H3V19Z"
            tooltip="Align text left"
            checked={textAlign === editorConstants.TEXT_ALIGN.LEFT}
            onClick={this.updateElement.bind(this, elementMethods.getTextAlignSetter.bind(this, editorConstants.TEXT_ALIGN.LEFT))}
          />
          <CustomSvgIconButtonPropMenu
            iconPath="M3,3H21V5H3V3M7,7H17V9H7V7M3,11H21V13H3V11M7,15H17V17H7V15M3,19H21V21H3V19Z"
            tooltip="Align text center"
            checked={textAlign === editorConstants.TEXT_ALIGN.CENTER}
            onClick={this.updateElement.bind(this, elementMethods.getTextAlignSetter.bind(this, editorConstants.TEXT_ALIGN.CENTER))}
          />
          <CustomSvgIconButtonPropMenu
            iconPath="M3,3H21V5H3V3M9,7H21V9H9V7M3,11H21V13H3V11M9,15H21V17H9V15M3,19H21V21H3V19Z"
            tooltip="Align text right"
            checked={textAlign === editorConstants.TEXT_ALIGN.RIGHT}
            onClick={this.updateElement.bind(this, elementMethods.getTextAlignSetter.bind(this, editorConstants.TEXT_ALIGN.RIGHT))}
          />
        </div>
      </div>
    );
  }
}

FontEmphasisAndAlign.propTypes = {
  isMobileView: PropTypes.bool.isRequired,
  style: PropTypes.object
};

FontEmphasisAndAlign.defaultProps = {
  isMobileView: false,
  style: {}
};